export const LISTVIEW_LOCALE = {
    emptyMessage: 'Empty Data',
    checkall: 'Check all'
};
